import { FC } from 'react';

import { FormLabel, Input, VSpacingContainer } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { AdfoxInfoRequiredField } from 'components/Admin/AdfoxInfo/buildAdfoxInfo';

import { updateAdfoxInfoForm } from 'store/models/adfoxInfo';
import { useDispatch, useSelector } from 'store/utils';

type OrdField = Exclude<AdfoxInfoRequiredField, 'ctaLabel'>;

const TrlKeys: Record<OrdField, string> = {
    advertiserName: 'admin.adfoxInfo.field.advertiserName',
    advertiserInn: 'admin.adfoxInfo.field.advertiserInn',
    erid: 'admin.adfoxInfo.field.erid',
};

const ORD_FIELDS: OrdField[] = ['advertiserName', 'advertiserInn', 'erid'];

const ORD_FIELD_DATA_QA: Record<OrdField, string> = {
    advertiserName: 'adfox-info-advertiser-name',
    advertiserInn: 'adfox-info-advertiser-inn',
    erid: 'adfox-info-erid',
};

export const OrdFields: FC = () => {
    const form = useSelector((state) => state.adfoxInfo);

    const trls = useTrls();
    const dispatch = useDispatch();

    return (
        <>
            {ORD_FIELDS.map((field) => (
                <VSpacingContainer key={field} default={12}>
                    <FormLabel>{trls(TrlKeys[field])}</FormLabel>
                    <Input
                        size="medium"
                        value={form[field]}
                        onChange={(value) => dispatch(updateAdfoxInfoForm({ [field]: value }))}
                        data-qa={ORD_FIELD_DATA_QA[field]}
                    />
                </VSpacingContainer>
            ))}
        </>
    );
};
